













import { Component, Prop, Vue } from 'vue-property-decorator';
import toggleMediaPlay from '@/common/MediaUtil';

@Component
export default class ExamAudio extends Vue {
  @Prop()
  elementId: string;

  @Prop()
  sourcePath: string;

  @Prop({ type: String, required: false, default: 'PLAY' })
  displayText: string;

  private localElementId = '';

  private localSourcePath = '';

  private localDisplayText = 'PLAY';

  private toggleMediaPlay = toggleMediaPlay;

  private mounted() {
    this.localElementId = this.elementId;
    this.localSourcePath = this.sourcePath;
    this.localDisplayText = this.displayText;
  }
}
